import { BUNDLES_CANCEL_BUNDLE } from 'apiRoutes';
import { ConfirmationModal } from 'components/common/ConfirmationModal/ConfirmationModal';
import useSubmit, { POST } from 'hooks/useSubmit';

export const CancelBundleModal: React.FC<{
	setShowModal: (show: boolean) => void;
	showModal: boolean;
	bundleId: number;
	onBundleCancelled: () => void;
}> = ({ setShowModal, showModal, bundleId, onBundleCancelled }) => {
	const [cancelBundle, status] = useSubmit(BUNDLES_CANCEL_BUNDLE, POST, {
		messageOnError: 'An error occurred, please try again!',
		messageOnSuccess: 'Bundle cancelled successfully',
		showApiError: true,
	});

	const onCancelBundle = async (comment?: string) => {
		const result = await cancelBundle({
			bundleId,
			comment: comment ?? null,
		});
		if (result.success) {
			onBundleCancelled();
			setShowModal(false);
		}
	};

	return (
		<ConfirmationModal
			showModal={showModal}
			setShowModal={setShowModal}
			onSubmit={onCancelBundle}
			header="Cancel Bundle"
			text="Cancelling a bundle will also cancel all subscriptions within the bundle. Are you sure you want to cancel this bundle?"
			buttonText="Cancel Bundle"
			loadingStatus={status}
		/>
	);
};
